import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import _ from 'lodash';
import { Breadcrumb, Tabs } from '../../../components';
import appConfig from '../../../config/app-config';

// Screens
import Information from './Information';
import ChangePassword from './ChangePassword';
import Portfolio from './Portfolio';
import Budget from './Budget';

const { IMAGE_PATH } = appConfig;

class Profile extends Component {
  componentWillMount() {
    const { location, history } = this.props;
    const routes = [
      '/perfil/informacoes',
      '/perfil/carteira',
      '/perfil/trocar-senha',
      '/perfil/budget',
    ];

    if (!_.includes(routes, location.pathname)) {
      history.push('/perfil/informacoes');
    }
  }

  componentDidMount() {
    const { loadUser } = this.props;
    loadUser();
  }

  logout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('user_token');
    localStorage.removeItem('showAdminMenu');
    window.location.href = '/login';
  };

  render() {
    const { user, match } = this.props;
    const valletPermission = user.nivel.id === 30 || user.nivel.id === 60;
    const nameUser = `${user.nome} ${user.sobreNome ? user.sobreNome : " "}`;

    return (
      <div>
        <Breadcrumb 
          title={`${nameUser}`}
          description="Perfil"
          image={`${IMAGE_PATH}${user.foto}`}
          renderRight={(() => (
            <div className="breadcrumb-right-actions">
              <button
                type="button"
                className="bx--btn btn-primary-color v-md-margin"
                onClick={this.logout}
              >
                Logout
              </button>
            </div>
          ))()}
        />

        <section className="content-wrapper">
          {valletPermission ? (
            <Tabs
              sections={[
                { title: 'Informações', path: `${match.url}/informacoes` },
                { title: 'Trocar senha', path: `${match.url}/trocar-senha` },
                { title: 'Carteira', path: `${match.url}/carteira` },
                { title: 'Budget', path: `${match.url}/budget` },
              ]}
            />
          ) :
            (
              <Tabs
                sections={[
                  { title: 'Informações', path: `${match.url}/informacoes` },
                  { title: 'Trocar senha', path: `${match.url}/trocar-senha` },
                  { title: 'Budget', path: `${match.url}/budget` }
                ]}
              />
            )}

          <Route path={`${match.url}/informacoes`} component={Information} />
          <Route path={`${match.url}/carteira`} component={Portfolio} />
          <Route path={`${match.url}/trocar-senha`} component={ChangePassword} />
          <Route path={`${match.url}/budget`} component={Budget} />
        </section>
      </div>
    );
  }
}

export default Profile;



// WEBPACK FOOTER //
// ./src/screens/client/profile/Profile.jsx